
import { Component, Vue } from 'vue-property-decorator';
import { WPXFormValue } from '@/components/templates/WPXForm';
import CreateScoreGradeForm from '@/services/QA/scoreGrade/forms/CreateScoreGradeForm';
import ScoreGradeRepositoryInterface, { ScoreGradeInterface } from '@/services/QA/scoreGrade/interfaces';

@Component({
  inject: [
    'scoreGradeRepository',
  ],
})
export default class CreateScoreGrade extends Vue {
  private readonly scoreGradeRepository!: ScoreGradeRepositoryInterface;
  private loading: boolean = true;
  private form: WPXFormValue<CreateScoreGradeForm> = new WPXFormValue(CreateScoreGradeForm);

  public created(): void {
    this.loading = false;
  }

  private async createScoreGrade(): Promise<void> {
    try {
      await this.scoreGradeRepository.createScoreGrade({
        label: this.form.data.label,
        value: Number(this.form.data.value),
      });

      this.$successDialog.show(`Score Grade '${this.form.data.label}' has been created`);
      await this.$router.push({ path: '/qc/score/grades' });
    } catch (err) {
      this.$errorDialog.show(err.response.data.message);
    }
  }
}
